const name = 'FadeOut';
const properties = {
    groups: ['exit', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
/**
 * FadeOut to opacity 0 animation object
 */
function animate(kit, elements, duration, delay, params) {
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        to: { autoAlpha: 0 },
        ease: 'Cubic.easeIn',
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=fadeOut.js.map